import React, { Component } from 'react';
import { connect } from 'react-redux'
import { BrowserRouter, Route, Routes} from "react-router-dom";
import { createBrowserHistory } from 'history'

import axios from 'axios'
import './App.css';

import AppHeader from './AppHeader'; 
import LeftPane from './containers/LeftPane'

import { fetchServers } from './actions/servers';
import { fetchPrinters } from './actions/printers';
import { fetchUsers } from './actions/users';
import {fetchUserGroups} from './actions/usergroups';
import { fetchComputers} from './actions/computers';
import { fetchLicense } from './actions/license';
import { fetchCompGroups } from './actions/compgroups';

import { Layout, ConfigProvider, Modal, theme } from 'antd';
import ruRU from 'antd/lib/locale/ru_RU';

import dayjs from 'dayjs';
import LocalizedFormat from 'dayjs/plugin/localizedFormat';
import 'dayjs/locale/ru';

import enMessages from './locales/en.json';
import ruMessages from './locales/ru.json';

import '@formatjs/intl-relativetimeformat/polyfill';
import '@formatjs/intl-relativetimeformat/locale-data/en'
import '@formatjs/intl-relativetimeformat/locale-data/ru'

import { IntlProvider } from 'react-intl';

import Cookies from 'universal-cookie';

import ServersPane from './containers/ServersPane';
import PrintersPane from './containers/PrintersPane';
import DocumentsPane from './containers/DocumentsPane';
import UsersPane from './containers/UsersPane';
import ComputersPane from './containers/ComputersPane';
import UsersGroupsPane from './containers/UsersGroupsPane';
import ComputersGroupsPane from './containers/ComputersGroupPane';
import HardwarePane from './containers/HardwarePane';
import SuppliesPane from './containers/SuppliesPane';
import SuppliesHistoryPane from './containers/SuppliesHistoryPane';
import DeviceMetersPane from './containers/DeviceMeters';
import EmailReportsPane from './containers/EmailReports';
import SMTPServerPane from './containers/SMTPServerPane';
import DBSettingsPane from './containers/DBSettingsPane';
import DBPollingPane from './containers/DBPollingPane';
import LicensePane from './containers/LicensePane';
import TasksPane from './containers/TasksPane';
import LoginPane from './containers/LoginPane';
import PasswordPane from './containers/PasswordPane';
import { isDev, IsAuthenticated, SetAuthenticated} from './utils/debug';
import { SUPPLIES_PATH, HISTORY_PATH, METERS_PATH, REPORTS_PATH, 
  SMTP_SERVER_PATH, HARDWARE_PATH, SERVERS_PATH, PRINTERS_PATH,
  DOCUMENTS_PATH, USERS_PATH, USERS_GROUPS_PATH, 
  COMPUTERS_PATH, DB_SETTINGS_PATH, LICENSE_PATH, TASKS_PATH, DB_POLLING_PATH, 
  LOGIN_PATH, PASSWORD_PATH, COMPUTERS_GROUPS_PATH,
  API_TOKEN} from './utils/constants';

if (isDev())
{
  axios.defaults.baseURL = "http://192.168.0.3:8989/api";
}
else
{
  axios.defaults.baseURL = "/api";
}

const cookies = new Cookies();

axios.interceptors.request.use(
  function(config) {
    config.headers['ApiToken'] = cookies.get(API_TOKEN);
    config.withCredentials = true;
    
    return config;
  },
  function(error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  function (response) {
    if (!IsAuthenticated())
    {
        SetAuthenticated(true);
    }

    return response;
  },
  function (error) {
    // Handle 401 Unauthorized response globally
    if (error.response && error.response.status === 401) 
    {
      if (error.response.headers["www-authenticate"] !== "NTLM")
      {
        SetAuthenticated(false);

        // Redirect to login page
        window.location.href = "/login";
      }
    }
    // Do something with response error
    return Promise.reject(error);
  }
);

const { /*Footer,*/ Content } = Layout;

var ant_locale = undefined;
var messages = enMessages;

const history = createBrowserHistory();

const unlisten = history.listen((location, action) => {
  Modal.destroyAll();
});

class App extends Component {

  onChangeLanguage = () => {
    dayjs.locale(this.props.language);
    dayjs.extend(LocalizedFormat);
    if (this.props.language === 'ru-RU')
    {
      ant_locale = ruRU;
      messages = ruMessages;
    }
    else
    {
      ant_locale = undefined;
      messages = enMessages;
    }
  }

  UpdateStore = () =>
  {
    if (IsAuthenticated())
    {
      this.props.fetchServers();
      this.props.fetchPrinters();
      this.props.fetchUsers();
      this.props.fetchUserGroups();
      this.props.fetchComputers();
      this.props.fetchLicense();
      this.props.fetchCompGroups();
    }  
  } 

  componentDidMount() {
    this.UpdateStore();
  }

  componentWillUnmount() {
   unlisten();
  }

  render() {
    this.onChangeLanguage();

    return (
      <div className="App">
      <ConfigProvider locale={ant_locale} theme={{algorithm: [theme.compactAlgorithm],}}>
      <IntlProvider locale={this.props.language} messages={messages}>
      <BrowserRouter location={history.location} navigator={history}>
          <Layout style={{ minHeight: '100vh' }}>
            <AppHeader/>
          <Layout style={{height:"100vh"}}>
            <LeftPane/>
          <Content style={{ margin: '2px 1px 0' }}>
            <div style={{ padding: 0, background: '#fff', height: '100%', minHeight: 360 }}>
              <Routes>
                <Route path={SERVERS_PATH + "/*"} element={<ServersPane/>}/>
                <Route path={PRINTERS_PATH + "/*"} element={<PrintersPane/>}/>
                <Route path={USERS_PATH + "/*"} element={<UsersPane/>}/>
                <Route path={COMPUTERS_PATH + "/*"} element={<ComputersPane/>}/>
                <Route path={USERS_GROUPS_PATH + "/*"} element={<UsersGroupsPane/>}/>
                <Route path={COMPUTERS_GROUPS_PATH + "/*"} element={<ComputersGroupsPane/>}/>
                <Route path={DOCUMENTS_PATH + "/*"} element={<DocumentsPane/>}/>
                <Route path={HARDWARE_PATH} element={<HardwarePane/>}/>
                <Route path={SUPPLIES_PATH} element={<SuppliesPane/>} />
                <Route path={HISTORY_PATH} element={<SuppliesHistoryPane/>} />
                <Route path={METERS_PATH} element={<DeviceMetersPane/>} />
                <Route path={REPORTS_PATH} element={<EmailReportsPane/>} />
                <Route path={SMTP_SERVER_PATH} element={<SMTPServerPane/>} />
                <Route path={DB_SETTINGS_PATH} element={<DBSettingsPane/>} />
                <Route path={DB_POLLING_PATH} element={<DBPollingPane/>} />
                <Route path={LICENSE_PATH} element={<LicensePane/>} />
                <Route path={TASKS_PATH} element={<TasksPane/>} />
                <Route path={LOGIN_PATH} element={<LoginPane/>} />
                <Route path={PASSWORD_PATH} element={<PasswordPane/>} />
                <Route path='*' element={<PrintersPane/>} />
              </Routes>
            </div>
          </Content>
        </Layout>
        {/*
        <Footer style={{ background: '#fff', padding: 0 }}>
          <div className='pw_footer'>
            <a href='https://www.prnwatch.com' target='_blank' rel="noopener noreferrer">O&K Software Ltd.</a>
          </div>
        </Footer>
        */}
        </Layout>
      </BrowserRouter>  
      </IntlProvider>
      </ConfigProvider>
      </div>
    );
  }
}

const mapStateToProps = store => {
  return {
    language: store.language.code,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
      fetchServers: () => dispatch(fetchServers()),
      fetchPrinters: () => dispatch(fetchPrinters()),
      fetchUsers: () => dispatch(fetchUsers()),
      fetchUserGroups: () => dispatch(fetchUserGroups()),
      fetchComputers: () => dispatch(fetchComputers()),
      fetchLicense: () => dispatch(fetchLicense()),
      fetchCompGroups: () => dispatch(fetchCompGroups()),
      };
  };

export default connect(mapStateToProps, mapDispatchToProps)(App)
